import React from 'react';

export function VennDiagram3(props) {
  return (
    <svg className={`svg venn-diagram ${props.className || ''}`} id="Color-c" x="0px" y="0px" viewBox="0 0 32 32">
      <path d="M25.622,12.689C25.862,11.832,26,10.933,26,10c0-5.514-4.486-10-10-10S6,4.486,6,10c0,0.933,0.138,1.832,0.378,2.689
        C2.651,14.144,0,17.764,0,22c0,5.514,4.486,10,10,10c2.253,0,4.326-0.758,6-2.019C17.674,31.242,19.747,32,22,32
        c5.514,0,10-4.486,10-10C32,17.764,29.349,14.144,25.622,12.689z M8,10c0-4.411,3.589-8,8-8s8,3.589,8,8
        c0,0.747-0.111,1.468-0.303,2.155C23.144,12.06,22.579,12,22,12c-2.253,0-4.326,0.758-6,2.019C14.326,12.758,12.253,12,10,12
        c-0.579,0-1.144,0.06-1.697,0.155C8.111,11.468,8,10.747,8,10z M18,22c0,2.021-0.759,3.864-2,5.274c-1.241-1.41-2-3.253-2-5.274
        c0-0.747,0.111-1.468,0.303-2.155C14.856,19.94,15.421,20,16,20s1.144-0.06,1.697-0.155C17.889,20.532,18,21.253,18,22z M16,18
        c-0.3,0-0.595-0.02-0.886-0.052c0.257-0.436,0.554-0.844,0.886-1.222c0.332,0.378,0.629,0.786,0.886,1.222
        C16.595,17.98,16.3,18,16,18z M13.106,17.45c-1.681-0.655-3.084-1.861-3.992-3.398C9.405,14.02,9.7,14,10,14
        c1.672,0,3.224,0.517,4.509,1.398C13.961,16.019,13.488,16.706,13.106,17.45z M17.491,15.398C18.776,14.517,20.328,14,22,14
        c0.3,0,0.595,0.02,0.886,0.052c-0.908,1.537-2.311,2.742-3.992,3.398C18.512,16.706,18.039,16.019,17.491,15.398z M2,22
        c0-3.39,2.123-6.287,5.106-7.45c1.112,2.165,2.987,3.869,5.272,4.761C12.138,20.168,12,21.067,12,22
        c0,2.531,0.953,4.839,2.509,6.602C13.224,29.483,11.672,30,10,30C5.589,30,2,26.411,2,22z M22,30c-1.672,0-3.224-0.517-4.509-1.398
        C19.047,26.839,20,24.531,20,22c0-0.933-0.138-1.832-0.378-2.689c2.284-0.892,4.16-2.596,5.272-4.761C27.877,15.713,30,18.61,30,22
        C30,26.411,26.411,30,22,30z" fill="#1A77BF"/>
    </svg>

  )
}
